// export const annotationConfig = [
//   {
//     key: 'A32A27E',
//     value: 'dent',
//     type: 'damage',
//     children: [
//       {
//         key: 'A38F575',
//         value: 'dent A',
//         type: 'sub damage',
//         children: [
//           {
//             key: '3A0EC5F',
//             value: 'level 3 A',
//             type: 'sub damage',
//             children: []
//           },
//           {
//             key: 'C75A392',
//             value: 'level 3 B',
//             type: 'sub damage',
//             children: []
//           },
//         ]
//       },
//       {
//         key: '024632B',
//         value: 'dent B',
//         type: 'sub damage',
//         children: []
//       },
//     ]
//   },
//   {
//     key: 'C75D2A3',
//     value: 'scratch',
//     type: 'damage',
//     children: [
//       {
//         key: '53F1C4D',
//         value: 'scratch A',
//         type: 'sub damage',
//         children: []
//       },
//       {
//         key: '74D6731',
//         value: 'scratch B',
//         type: 'sub damage',
//         children: []
//       },
//     ]
//   },
//   {
//     key: '4C23AAF',
//     value: 'front',
//     type: 'damage',
//     children: [
//       {
//         key: 'A6D4175',
//         value: 'front fender',
//         type: 'sub damage',
//         children: []
//       },
//     ]
//   },
// ]

export const annotationConfig =[
  {
      key: "12cc",
      value: "Left_Lt_Pillar_Front(A)",
      type: "damage",
      children: []
  },
  {
      key: "9540",
      value: "Left_Front_Door_Glass",
      type: "damage",
      children: []
  },
  {
      key: "e344",
      value: "Left_Rear_View_Mirror",
      type: "damage",
      children: []
  },
  {
      key: "02f8",
      value: "Left_Front_Rim",
      type: "damage",
      children: []
  },
  {
      key: "e9d8",
      value: "Car",
      type: "damage",
      children: []
  },
  {
      key: "1abe",
      value: "Left_Lt_Front_Door",
      typen: "damage",
      children: []
  },
  {
      key: "13c9",
      value: "Left_Front_Tyre",
      type: "damage",
      children: []
  },
  {
      key: "bb79",
      value: "Dent",
      type: "damage",
      children: []
  },
  {
      key: "b192",
      value: "Left_Fender",
      type: "damage",
      children: []
  },
  {
    key: "windshield",
    value: "Windshield",
    type: "damage",
    children: []
},
  {
      key: "8abc",
      value: "Scratch",
      type: "damage",
      children: []
  },
  {
    key: "09q2",
    value: "Broken",
    type: "damage",
    children: []
},
  {
      key: "6715",
      value: "Left_Lt_Pillar_Rear(C)",
      type: "damage",
      children: []
  },
  {
      key: "fd63",
      value: "Left_Lt_Pillar_Center(B)",
      type: "damage",
      children: []
  },
  {
      key: "72e4",
      value: "Left_Lt_Rear_Door",
      type: "damage",
      children: []
  },
  {
      key: "8359",
      value: "Left_Rear_Door_Glass",
      type: "damage",
      children: []
  },
  {
      key: "7f57",
      value: "Left_Rear_Tyre",
      type: "damage",
      children: []
  },
  {
      key: "d35d",
      value: "Left_Lt_Qtr_Panel",
      type: "damage",
      children: []
  },
  {
       key: "0f13",
       value: "Left_Rear_Rim",
       type: "damage",
       children: []
  },
  {
       key: "260b",
       value: "Left_Lt_Running_Board",
       type: "damage",
       children: []
  },
  {
       key: "6f8a",
       value: "Front_Front_Bumper",
       type: "damage",
       children: []
  },
  {
       key: "882a",
       value: "Front_Grill",
       type: "damage",
       children: []
  },
  {
       key: "03dd",
       value: "Front_Head_Lamp(RT)",
       type: "damage",
       children: []
  },
  {
       key: "686b",
       value: "Front_Head_Lamp(LT)",
       type: "damage",
       children: []
  },
  {
      key: "5fd9",
      value: "Front_Bonnet",
      type: "damage",
      children: []
  },
  {
      key: "31d4",
      value: "Front_Indicator_Light(RT)",
      type: "damage",
      children: []
  },
  {
      key: "c7f4",
      value: "Front_Front_Panel",
      type: "damage",
      children: []
  },
  {
      key: "a051",
      value: "Front_Left_Apron",
      type: "damage",
      children: []
  },
  {
      key: "60ac",
      value: "Front_Indicator_Light(LT)",
      type: "damage",
      children: []
  },
  {
      key: "7f02",
      value: "Front_Fog_Lamp(RT)",
      type: "damage",
      children: []
  },
  {
      key: "e511",
      value: "Front_Right_Apron",
      type: "damage",
      children: []
  },
  {
      key: "5d60",
      value: "Front_Fog_Lamp(LT)",
      type: "damage",
      children: []
  },
  {
      key: "9f12",
      value: "Right_Front_Door_Glass",
      type: "damage",
      children: []
  },
  {
      key: "1a26",
      value: "Right_Rear_View_Mirror",
      type: "damage",
      children: []
  },
  {
      key: "2028",
      value: "Right_Pillar_Front(A)",
      type: "damage",
      children: []
  },
  {
      key: "0844",
      value: "Right_Pillar_Rear(C)",
      type: "damage",
      children: []
  },
  {
      key: "8a49",
      value: "Right_Pillar_Center(B)",
      type: "damage",
      children: []
  },
  {
      key: "edbf",
      value: "Right_Front_Door",
      type: "damage",
      children: []
  },
  {
      key: "bf75",
      value: "Right_Fender",
      type: "damage",
      children: []
  },
  {
      key: "1845",
      value: "Front_Windscreen",
      type: "damage",
      children: []
  },
  {
      key: "c168",
      value: "Right_Front_Rim",
      type: "damage",
      children: []
  },
  {
      key: "f5bb",
      value: "Right_Front_Tyre",
      type: "damage",
      children: []
  },
  {
      key: "1aa8",
      value: "Right_Rear_Door",
      type: "damage",
      children: []
  },
  {
      key: "e428",
      value: "Rear_Rear_Bumper",
      type: "damage",
      children: []
  },
  {
      key: "28d1",
      value: "Rear_Tail_Lamp(LT)",
      type: "damage",
      children: []
  },
  {
      key: "ed14",
      value: "Rear_Dicky",
      type: "damage",
      children: []
  },
  {
      key: "0279",
      value: "Rear_Rear_Glass",
      type: "damage",
      children: []
  },
  {
      key: "922b",
      value: "Right_Rear_Tyre",
      type: "damage",
      children: []
  },
  {
      key: "61e1",
      value: "Right_Rear_Rim",
      type: "damage",
      children: []
  },
  {
      key: "7d3b",
      value: "Right_Qtr_Panel",
      type: "damage",
      children: []
  },
  {
      key: "b719",
      value: "Right_Door_Glass",
      type: "damage",
      children: []
  },
  {
      key: "a7c7",
      value: "Right_Running_Board",
      type: "damage",
      children: []
  },
  {
      key: "055e",
      value: "Rear_Spare_Tyre",
      type: "damage",
      children: []
  },
  {
      key: "05a5",
      value: "Rear_Tail_Lamp(RT)",
      type: "damage",
      children: []
  }
]
